import { Loader, useModal } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { GatewayEndorsementService as LoadSaveService } from 'twia-capability-gateway-policychange';
import { useTranslator, IntlContext } from '@jutro/locale';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import TWIADateFormatUtil from 'ent-capability-quoteandbind-common-react/util/TWIADateFormatUtil';
import Echeck from 'twia-capability-quoteandbind-residential-react/components/Echeck/Echeck';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import metadata from './PaymentDetailsPage.metadata.json5';
import messages from './PaymentDetails.messages';
import styles from './PaymentDetails.module.scss';

function TFPAChangePaymentDetailsPage(props) {
    const {
        wizardData: submissionVM,
        updateWizardData
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const intlContext = useContext(IntlContext);
    const { showAlert, showConfirm } = useModal();
    const history = useHistory();
    const jobID = submissionVM.jobID.value;
    const sessionID = submissionVM.sessionUUID.value;
    const totalCost = _.get(submissionVM, 'totalCost.amount.value');
    const previousTotal = _.get(submissionVM, 'previousTotalCost.amount.value');
    const periodEndDate = _.get(submissionVM, `baseData.periodEndDate.value`);
    const periodStartDate = _.get(submissionVM, `baseData.periodStartDate.value`);
    const eftEnabled = _.get(submissionVM, 'bindData_TFPA.eftEnabled_TWIA.value');
    const changeInCost = totalCost - previousTotal;
    const increase = changeInCost > 0;
    const translator = useTranslator();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [showError, setShowError] = useState(false);
    const { authHeader } = useAuthentication();
    const [showSubmitLoader, setShowSubmitLoader] = useState(false);
    const { isComponentValid, disregardFieldValidation, onValidate } =
        useValidation('TWIAChangePaymentDetailsPage');

    const formatPolicyPeriod = (startDate, endDate) => {
        if (!_.isUndefined(startDate) && !_.isUndefined(endDate)) {
            const formattedStartDate = TWIADateFormatUtil.formatDate(startDate);
            const formattedEndDate = TWIADateFormatUtil.formatDate(endDate);

            return `${formattedStartDate} - ${formattedEndDate}`;
        }
       
    };

    useEffect(()=>{
        _.set(submissionVM,"bindData_TFPA.paymentDetails.value",{})
        updateWizardData(submissionVM)
    },[])

    const handleNext = useCallback(() => {
        showConfirm({
            title: messages.confirmTransaction,
            message: messages.confirmTransactionMsg,
            status: 'warning',
            icon: 'gw-help',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
            // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            setShowSubmitLoader(true);

            const checkUwIssues = CustomQuoteService.getUWIssueStatus(jobID, sessionID,
                authHeader);

            checkUwIssues.then((result) => {
                if (result.anyPolicyHoldUWIssues || result.anyOtherBlockingUWIssues) {
                    setShowSubmitLoader(false);
                    showAlert({
                        title: messages.uwIssueTitle,
                        message: messages.uwIssueMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.uwActionLabel,
                    }).then((res) => {
                        if (res === 'confirm') {
                            submissionVM.noCancelWarning = true;
                            history.push(`${process.env.PUBLIC_PATH}/change/${submissionVM.jobID.value}/summary`)
                        }
                    })
                }
                else {
                    const job = _.cloneDeep(submissionVM.value);

                    _.set(job,"bindData_TFPA.paymentDetails.paymentMethod","redistribute")

                    const submit = LoadSaveService.bind([jobID,job.bindData_TFPA.paymentDetails],
                        authHeader);

                    submit.then((response) => {

                        submissionVM.value = response;
                        updateWizardData(submissionVM);
                        setShowSubmitLoader(false);
                        submissionVM.noCancelWarning = true;
                        history.push({
                            pathname: '/endorsementConfirmation',
                            state: {
                                response,
                                authHeader
                            },
                        })
                    }).catch((err) => {
                        setShowSubmitLoader(false);

                        const errorCode = _.get(err, 'appErrorCode');

                        switch (errorCode) {
                            case 602: // DE18261
                                showAlert({
                                    title: messages.uwIssueTitle,
                                    message: messages.uwIssueMessage,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: messages.uwActionLabel,
                                }).then(() => {
                                    // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                                    submissionVM.noCancelWarning = true;
                                    // DE18441
                                    history.push(`${process.env.PUBLIC_PATH}/change/${submissionVM.jobID.value}/summary`)
                                })
                                break;
                            case 601:
                                showAlert({
                                    title: messages.uwIssueTitle,
                                    message: messages.uwIssueMessage,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: messages.uwActionLabel,
                                }).then(() => {
                                    // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                                    submissionVM.noCancelWarning = true;
                                    // DE18441
                                    history.push(`${process.env.PUBLIC_PATH}/change/${submissionVM.jobID.value}/summary`)
                                })
                                break;
                            case 10075:
                                showAlert({
                                    title: messages.invalidBank,
                                    message: messages.badBank,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.ok,
                                })
                                break;
                            case 10074:
                                showAlert({
                                    title: messages.paymentThreshold,
                                    message: messages.paymentThresholdMsg,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.ok,
                                })
                                break;
                            default:
                                ErrorPopupUtil.showSaveErrorPopup(showAlert, false);
                                break;
                        }

                        return false;
                    });
                }
            }, _.noop)
        })
    }, [authHeader, history, jobID, sessionID, showAlert, 
        showConfirm, submissionVM, updateWizardData]);

    const diffCost = useCallback(() => {
        const formattedDiffCost = intlContext.formatNumber(changeInCost, {
            style: 'currency',
            currency: 'USD'
        });

        if (increase) {
            return `+${formattedDiffCost}`;
        }

        return formattedDiffCost;
    }, [changeInCost, increase, intlContext]);

    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        changeInPremium: {
            value: diffCost()
        },
        proposedPolicyPeriod: {
            value: formatPolicyPeriod(periodStartDate, periodEndDate)
        },
        creditDueMessage: {
            visible: changeInCost < 0,
            content: translator(messages.creditDue)
        },
        distributedMessage: {
            visible: changeInCost > 0 ,
            content: translator(messages.differenceDistributed)
        },
        paymentMethod:{
            availableValues:[{name: "Invoice", code: "invoice"}],
            value: "invoice",
            visible: changeInCost > 0
        }
    };

    const resolvers = {
        resolveComponentMap: {
            
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            nextLabel={messages.paymentBuyNow}
            showNext={!showSubmitLoader}
            showPrevious={_.get(submissionVM, 'status.value') === 'Submitted_Ext'
                ? false : !showSubmitLoader}
            showCancel={!showSubmitLoader}
            hideHeader={showSubmitLoader}
            onNext={handleNext}
            //onPrevious={resetElectronicPaymentData}
            disableNext={!isComponentValid}
        >
            {!showSubmitLoader ?
                (
                    <ViewModelForm
                        uiProps={metadata.pageContent}
                        model={submissionVM}
                        onModelChange={updateWizardData}
                        onValidationChange={onValidate}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        showErrors={showError}
                        componentMap={resolvers.resolveComponentMap}
                    />
                ) :
                (<Loader
                    loaded={!showSubmitLoader}
                    text="Processing Transaction..."
                />)}
        </WizardPage>
    );
}

TFPAChangePaymentDetailsPage.propTypes = wizardProps;
export default TFPAChangePaymentDetailsPage;